module.exports = __webpack_public_path__ + "static/img/rank_background2.afc4b04c.png";